import axios from 'axios';
import { PhotoListResponse, PhotoWithDetails, Agent, Client, PhotoCategory, PhotoQuery, User } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Interceptor для добавления токена авторизации
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для обработки ошибок авторизации
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Токен истек или недействителен
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Photos API
export const photosApi = {
  getPhotos: async (query: PhotoQuery = {}): Promise<PhotoListResponse> => {
    const params = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/photos?${params.toString()}`);
    return response.data;
  },

  getPhoto: async (id: number): Promise<PhotoWithDetails> => {
    const response = await api.get(`/photos/${id}`);
    return response.data;
  },
};

// Agents API
export const agentsApi = {
  getAgents: async (): Promise<Agent[]> => {
    const response = await api.get('/agents');
    return response.data;
  },

  getAgent: async (id: number): Promise<Agent> => {
    const response = await api.get(`/agents/${id}`);
    return response.data;
  },
};

// Clients API
export const clientsApi = {
  getClients: async (search?: string): Promise<Client[]> => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await api.get(`/clients${params}`);
    return response.data;
  },

  getClient: async (id: number): Promise<Client> => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },
};

// Categories API
export const categoriesApi = {
  getCategories: async (): Promise<PhotoCategory[]> => {
    const response = await api.get('/categories');
    return response.data;
  },

  getCategory: async (id: number): Promise<PhotoCategory> => {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  },
};

// Users API
export const usersApi = {
  getUsers: async (): Promise<User[]> => {
    const response = await api.get('/auth/users');
    return response.data;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  updateUserRole: async (userId: number, role: string): Promise<User> => {
    const response = await api.put(`/auth/users/${userId}/role`, { role });
    return response.data;
  },
};

export default api;